import {
  DueDateConfigurationType,
  SettlementSettingDto,
  TransactionPartType,
} from '@g2-shared/api-client/generated/settlement-app';

export const DueDateConfigurationTypeLabelMapper: Record<DueDateConfigurationType, string> = {
  [DueDateConfigurationType.ACCOUNTING_SETTLEMENT]: 'Accounting',
  [DueDateConfigurationType.ROLLING_SETTLEMENT]: 'Rolling',
  [DueDateConfigurationType.AMOUNT_WITH_ROLLING_SETTLEMENT]: 'Amount_with_rolling',
  [DueDateConfigurationType.AMOUNT_WITH_ACCOUNTING_SETTLEMENT]: 'Amount_with_accounting',
};

export const isRollingDueDateConfigurationType = (configurationType: DueDateConfigurationType) => {
  return (
    configurationType === DueDateConfigurationType.ROLLING_SETTLEMENT ||
    configurationType === DueDateConfigurationType.AMOUNT_WITH_ROLLING_SETTLEMENT
  );
};

export const isAccountingDueDateConfigurationType = (
  configurationType: DueDateConfigurationType
) => {
  return (
    configurationType === DueDateConfigurationType.ACCOUNTING_SETTLEMENT ||
    configurationType === DueDateConfigurationType.AMOUNT_WITH_ACCOUNTING_SETTLEMENT
  );
};

export const shouldDueDateConfigurationTypeHavAmountParameter = (
  configurationType: DueDateConfigurationType,
  dueDateTransactionPartType: TransactionPartType
) => {
  return (
    (configurationType === DueDateConfigurationType.AMOUNT_WITH_ACCOUNTING_SETTLEMENT ||
      configurationType === DueDateConfigurationType.AMOUNT_WITH_ROLLING_SETTLEMENT) &&
    dueDateTransactionPartType === TransactionPartType.PRINCIPAL
  );
};

export const getConfigurationTypesFromSettlementSetting = (
  setting: SettlementSettingDto
): DueDateConfigurationType[] => {
  const configurationTypes: DueDateConfigurationType[] = [];

  if (setting.accountingEnabled) {
    configurationTypes.push(DueDateConfigurationType.ACCOUNTING_SETTLEMENT);
  }
  if (setting.amountWithAccountingEnabled) {
    configurationTypes.push(DueDateConfigurationType.AMOUNT_WITH_ACCOUNTING_SETTLEMENT);
  }
  if (setting.rollingEnabled) {
    configurationTypes.push(DueDateConfigurationType.ROLLING_SETTLEMENT);
  }
  if (setting.amountWithRollingEnabled) {
    configurationTypes.push(DueDateConfigurationType.AMOUNT_WITH_ROLLING_SETTLEMENT);
  }

  return configurationTypes;
};
